import React, { Component } from 'react';
import '../report-page.component.css';
import { HorizontalBarGraph } from '../../../common/graph/bar-graph.component';
import { ChartHeaderDropdown } from '../../../common/data-header/chart-header-dropdown.component';

const graphData = [
        { name: "Language skills of our personnel", value:4.70},
        { name: "The ability of the support personnel to understand", value:4.65},
        { name: "The completeness of the solution provided", value:4.58},
        { name: "The promptness of the solution provided", value:4.42}
  ];

class AverageRating extends Component {

    
    render() {        
        return (
            <div className="component-container"> 
                <ChartHeaderDropdown haveOneIcone={true} haveIconInfo={true} iconInfo="info-circle-solid" haveLedger={false} headerName="Top 5 Countries" circleIcon={false} circleFirstIcon="list-regular" circleSecondIcon="th-solid" oneIcon="vertical-grid" 
                          haveInput={false} haveDropdown={false}   />  
                <HorizontalBarGraph data={graphData} fill="#0071cc" withMargin={true} />  
            </div>
        )
    }

}

export default AverageRating;